// Categorias fixas do blog + utilitário de tempo de leitura.
// Os artigos agora vivem no MongoDB (gerenciados pela aba Conteúdo do /admin) e chegam via GET /api/articles.

export const CATEGORIES = [
  { slug: "direcao-de-marca", name: "Direção de Marca", desc: "Posicionamento, percepção e diferenciação." },
  { slug: "decisoes-de-crescimento", name: "Decisões de Crescimento", desc: "Estratégia, expansão e novos ciclos." },
  { slug: "consumidor-e-mercado", name: "Consumidor & Mercado", desc: "Comportamento, escolhas e contexto competitivo." },
  { slug: "ia-tecnologia-e-marcas", name: "IA, Tecnologia & Marcas", desc: "Como tecnologia está transformando marcas e decisões." },
  { slug: "na-pratica", name: "Na Prática", desc: "Ferramentas, diagnósticos e aplicações." },
  { slug: "perspectivas-fuchs", name: "Perspectivas FUCHS", desc: "Ideias, análises e pontos de vista." },
];

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);

export const readingTime = (article) => {
  const words = article.content
    .flatMap((b) => (b.items ? b.items.map((it) => (typeof it === "string" ? it : `${it.lead} ${it.text}`)) : [b.text || ""]))
    .join(" ")
    .split(/\s+/).length;
  return Math.max(1, Math.ceil(words / 200));
};
